/**
 * d16n::legacy
 * d16n::source:PProductDetail.vue
 * d16n::helpers-file
 */

import type { Ref } from 'vue'
import type { CategoryHit } from '@b2ag/search/src/search.service'
import type { BreadCrumb } from '@b2ag/search/src/types/BreadCrumb'
import { PRODUCT_TYPES } from '../../domain/product'
import {
  CROP_PROTECTION_KIND,
  CULTURE_EQUIPMENT_KIND,
  FARMER_EQUIPMENTS_KIND,
  FARM_DEVELOPMENT_KIND,
  NUTRITION_AMENDMENTS_KIND,
  SEED_KIND,
  SERVICE_KIND,
  VINE_EQUIPMENT_KIND,
} from '../../domain/products.constants'
import type { Product } from '../typings'
import { DisplayType } from '../typings'
import { i18n } from '@b2ag/locale'
import { featuresForCurrentBrand } from '@b2ag/app-brands/dist/features'

export function chooseFamilyLayout(product: Product): string | null {
  if (!product || (!product.kind && !product.displayType)) {
    return 'p-product-generic'
  }

  if (featuresForCurrentBrand.pdp.templateB2AGFeature) {
    switch (product.displayType) {
      case DisplayType.GENERIC:
        return 'p-product-generic'
      case DisplayType.PHYTO:
        return product.type && product.type === PRODUCT_TYPES.PACK ? 'p-pack-product-B2AG' : 'p-product-B2AG'
      case DisplayType.ENGRAIS:
      case DisplayType.SEMENCE:
      case DisplayType.SERVICE:
      case DisplayType.EQE:
      case DisplayType.EQC:
      case DisplayType.AME:
        return 'p-product-B2AG'
      default:
        return getFamilyLayoutByKind(product)
    }
  }

  return 'p-product-generic'
}

// TODO: remove this function when all products have a displayType
function getFamilyLayoutByKind(product: Product): string | null {
  switch (product.kind) {
    case CROP_PROTECTION_KIND: {
      return product.type && product.type === PRODUCT_TYPES.PACK ? 'p-pack-product-B2AG' : 'p-product-B2AG'
    }
    case NUTRITION_AMENDMENTS_KIND:
    case FARMER_EQUIPMENTS_KIND:
    case CULTURE_EQUIPMENT_KIND:
    case VINE_EQUIPMENT_KIND:
    case FARM_DEVELOPMENT_KIND:
    case SERVICE_KIND:
    case SEED_KIND: {
      return 'p-product-B2AG'
    }
    default:
      return 'p-product-generic'
  }
}

export function buildBreadcrumbs(product: Product, categoriesByPath: Ref<Map<string, CategoryHit>>) {
  const entries: Array<BreadCrumb> = []

  if (!product) {
    return entries
  }
  entries.push({ name: i18n._('Accueil'), route: { name: 'home' } })

  entries.push({ name: i18n._('Tous les produits'), route: { name: 'search' } })

  if (product.main_category && product.main_category.length > 0) {
    let currentPath = ''

    product.main_category.forEach((category) => {
      currentPath = currentPath ? `${currentPath} > ${category.label}` : category.label

      const slugCategory = categoriesByPath.value.get(currentPath)?.slug

      if (slugCategory) {
        entries.push({
          name: category.label,
          route: {
            name: 'category',
            params: { slug: slugCategory },
          },
        })
      }
    })
  }

  entries.push({
    name: product.name,
    route: undefined,
  })

  return entries
}
